import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfigService } from 'src/environments/app-config.service';
import {
  TransferenceModalAction,
  TransferenceResultModalViewModel,
} from '../transference-result-modal.model';

@Component({
  standalone: true,
  selector: 'app-modal-success-transference',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-success-transference.component.html',
  styleUrls: ['./modal-success-transference.component.scss'],
})
export class ModalSuccessTransferenceComponent {
  @Input() open = false;
  @Input() viewModel: TransferenceResultModalViewModel = {
    mode: 'success',
    heading: 'Sucesso!',
    icon: 'check_circle',
    iconTone: 'success',
    bodyText: 'Transferência dos créditos foi realizada com sucesso.',
  };

  @Output() action = new EventEmitter<TransferenceModalAction>();

  private supportUrl = '';

  constructor(appConfig: AppConfigService) {
    this.supportUrl = appConfig.config?.urlSuporteB3 ?? 'https://atendimento.b3.com.br/atendeb3';
  }

  onModalDismiss(): void {
    this.action.emit('dismiss');
  }

  onNewTransference(): void {
    this.action.emit('clear');
  }

  onConsultOperation(): void {
    this.action.emit('consult');
  }

  onRetry(): void {
    this.action.emit('retry');
  }

  onSupport(): void {
    if (this.supportUrl) {
      window.open(this.supportUrl, '_blank');
    }
    this.action.emit('dismiss');
  }
}
